import { DebtorSearchCriteriaComponent } from "projects/reg-hub-client/src/app/orders/debtor-search-criteria/debtor-search-criteria.component";
import { DebtorSearchReviewComponent } from "projects/reg-hub-client/src/app/orders/debtor-search-review/debtor-search-review.component";
import { SearchStepper, eCriteriaVariation } from "../search-stepper";
import { StepValidationState } from "projects/reg-hub-client/src/interfaces/step";

export class ABDebtorSearchStepper extends SearchStepper {

    constructor() {
        super()
        this.configuration = [
            eCriteriaVariation.ExactSimilar,
            eCriteriaVariation.FirstMiddleLast,
            eCriteriaVariation.DateOfBirth
        ];

        this.steps = [
            { title: "Search Criteria", content: DebtorSearchCriteriaComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: DebtorSearchReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}